import React from 'react'

import LABEL from '../../../business-const/Label/Label'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import {
    CardGridEntradaDados,
    CardGridDividerElementos,
    CardGridDivBodyEntradaDados,
} from '../../../business-components/Card/Card'

import {
    GridContainer,
    GridItem3xs4,
    GridItem3xs6,
    GridItem6,
    GridItem6sm12xs12,
} from '../../../business-components/Grid/Grid'

import { 
    TextValidatorText,
} from '../../../business-components/TextValidator/TextValidator'

import { 
    TextFieldTextSelect,
} from '../../../business-components/TextField/TextFieldSelect'

//import {
//    pesquisaList
//} from '../../../business-rules/List/ListService'

//import formList from '../../../business-rules/List/formList'

import grauInstrucaoList from '../../../business-rules/List/grauInstrucaoList'

import {
    CardGridDivHeaderEntradaDadosCliente,
    NomeCliente,
    NascimentoCliente,
    IdadeCliente,
    SexoCliente,
    CepEnderecoCliente,
    NomeCurtoCliente,
    CpfCliente,
    RgCliente,
    IdClienteIntegracaoCRM,
    OrigemCliente,
    PossuiConjuge,
    TipoRegimeBens,
    Meacao,
    EstadoCivil,
    TipoIRCliente,
    TipoCarteiraInvestimentoCliente,
    MomentoCliente,
    //ObservacaoCliente,
    ProfissaoCliente,
    ProfissaoClienteOutras,
    ContatoCliente,
    ContaInvestimentosCliente,
    AvatarCliente,
} from './CadastroCompCliente'



const CadastroFormCliente = ({ variaveisGlobais, values, handleChange, handleSubmit, setFieldValue, vars, linhaFormList  }) => {
    
    //const linhaFormList = pesquisaList(formList, values.idFormList)

    return (
        <GridItem6sm12xs12>
            <CardGridEntradaDados>
                <CardGridDivHeaderEntradaDadosCliente
                    variaveisGlobais={variaveisGlobais}
                    values={values}
                    handleChange={handleChange}
                    handleSubmit={handleSubmit}
                    setFieldValue={setFieldValue}
                    vars={vars}
                    linhaFormList={linhaFormList}
                />

                <CardGridDivBodyEntradaDados>
                    <GridContainer>
                        <NomeCliente
                            values={values}
                            handleChange={handleChange}
                            jsonConfiguracao={vars.jsonConfiguracao}
                        />
                    </GridContainer>

                    <GridContainer>
                        <NascimentoCliente
                            values={values}
                            setFieldValue={setFieldValue}
                        />
                        <IdadeCliente
                            values={values}
                            handleChange={handleChange}
                        />
                        <GridItem3xs6>
                            <SexoCliente
                                values={values}
                                handleChange={handleChange}
                            />
                        </GridItem3xs6>
                        {!vars.jsonUsuario.utilizarEstudoCompleto && (
                            <CepEnderecoCliente
                                variaveisGlobais={variaveisGlobais}
                                values={values}
                                handleChange={handleChange}
                                handleSubmit={handleSubmit}
                            />
                        )}
                    </GridContainer>

                    <GridContainer>
                        <NomeCurtoCliente
                            values={values}
                            handleChange={handleChange}
                        />
                        
                        <CpfCliente
                            values={values}
                            handleChange={handleChange}
                            jsonConfiguracao={vars.jsonConfiguracao}
                        />
                    </GridContainer>

                    <GridContainer>
                        <IdClienteIntegracaoCRM
                            values={values}
                            handleChange={handleChange}
                        />

                        <RgCliente
                            values={values}
                            handleChange={handleChange}
                        />
                    </GridContainer>

                    <CardGridDividerElementos/>
                        
                    <GridContainer>
                        <GridItem3xs4>
                            <PossuiConjuge
                                values={values}
                                handleChange={handleChange}
                            />
                        </GridItem3xs4>
                        <TipoRegimeBens
                            values={values}
                            handleChange={handleChange}
                        />
                        <Meacao
                            values={values}
                            handleChange={handleChange}
                        /> 
                    </GridContainer>

                    <GridContainer>
                        <GridItem3xs4/>
                        
                        <TipoIRCliente
                            values={values}
                            handleChange={handleChange}
                        />
                        
                        <EstadoCivil
                            values={values}
                            handleChange={handleChange}
                        />
                    </GridContainer>
                    
                    <CardGridDividerElementos/>

                    <OrigemCliente
                        variaveisGlobais={variaveisGlobais}
                        values={values}
                        handleChange={handleChange}
                    />

                    <GridContainer>
                        {linhaFormList.informaTipoCarteiraInvestimentoCliente === "S"
                            ?
                                <TipoCarteiraInvestimentoCliente
                                    variaveisGlobais={variaveisGlobais}
                                    values={values}
                                    handleChange={handleChange}
                                    idConfiguracao={vars.idConfiguracao}
                                />
                            :
                                ''
                        }
                        <MomentoCliente
                            values={values}
                            handleChange={handleChange}
                        />
                    </GridContainer>
                    
                    {/*
                    <ObservacaoCliente
                        values={values}
                        handleChange={handleChange}
                    />
                    */}

                    <CardGridDividerElementos/>

                    <GridContainer>
                        <GridItem6>
                            <TextFieldTextSelect
                                name="grauInstrucaoCliente"
                                label={LABEL.grauInstrucao}
                                value={values.grauInstrucaoCliente || ''}
                                onChange={handleChange}
                                list={grauInstrucaoList}
                            />
                        </GridItem6>
                        <GridItem6>
                            <TextValidatorText
                                name="formacaoCliente"
                                label={LABEL.formacao}
                                value={values.formacaoCliente || ''}
                                onChange={handleChange}
                                tamMax={TAMMAX.formacao}
                            />
                        </GridItem6>
                    </GridContainer>

                    <GridContainer>
                        <ProfissaoCliente
                            values={values}
                            handleChange={handleChange}
                        />

                        <GridItem6>
                            <TextValidatorText
                                name="empresaCliente"
                                label={LABEL.empresa}
                                value={values.empresaCliente || ''}
                                onChange={handleChange}
                                tamMax={TAMMAX.empresa}
                            />
                        </GridItem6>

                        <ProfissaoClienteOutras
                            values={values}
                            handleChange={handleChange}
                        />

                        <GridItem6>
                            <TextValidatorText
                                name="ocupacaoCliente"
                                label={LABEL.ocupacao}
                                value={values.ocupacaoCliente || ''}
                                onChange={handleChange}
                                tamMax={TAMMAX.ocupacao}
                            />
                        </GridItem6>
                    </GridContainer>

                    <CardGridDividerElementos/>

                    <ContatoCliente
                        values={values}
                        handleChange={handleChange}
                        jsonConfiguracao={vars.jsonConfiguracao}
                    />

                    <CardGridDividerElementos/>
                    
                    <ContaInvestimentosCliente
                        values={values}
                        handleChange={handleChange}
                    />

                    <CardGridDividerElementos/>

                    <AvatarCliente
                        values={values}
                        setFieldValue={setFieldValue}
                    /> 
                </CardGridDivBodyEntradaDados>
            </CardGridEntradaDados>
        </GridItem6sm12xs12>
    )
}

export default CadastroFormCliente
